import { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import inventoryManagementService from "services/inventory-items-service";

// MUI and Material Dashboard components
import MDBox from "components/MDBox";
import DashboardLayout from "e4acomponents/LayoutContainers/DashboardLayout";
import DashboardNavbar from "e4acomponents/Navbars/DashboardNavbar";

export default function DownloadReport() {
    const navigate = useNavigate();
    const [file, setFile] = useState(null);
    const [title, setTitle] = useState("Please wait while we are generating your report...");
    const [subtitle, setSubtitle] = useState("This will take a few seconds");
    const timersRef = useRef({timeoutId: null, intervalId: null});

    useEffect(() => {
        (async () => {
            const response = await inventoryManagementService.generateReport();
            setFile(response);
        })();
    }, []);

    useEffect(() => {
        if (file) {
            const url = window.URL.createObjectURL(new Blob([file]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'inventory-report.csv');
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
            // Update the title and subtitle after the file download starts
            const timeoutId = setTimeout(() => {
                setTitle("Your download has started successfully");
                let countdown = 5;
                changeSubtitle(countdown);

                const intervalId = setInterval(() => {
                    countdown--;
                    if (countdown > 0) {
                        changeSubtitle(countdown);
                    } else {
                        clearInterval(intervalId);
                        navigate(-1, { replace: true });
                    }
                }, 1000);

                timersRef.current.intervalId = intervalId;
            }, 2000);

            timersRef.current.timeoutId = timeoutId;

            // Cleanup when component unmounts
            return () => {
                if (timersRef.current.timeoutId) clearTimeout(timersRef.current.timeoutId);
                if (timersRef.current.intervalId) clearInterval(timersRef.current.intervalId);
            };
        }
    }, [file]);

    const changeSubtitle = (seconds) => {
        setSubtitle(`You will be redirected to the previous page in ${seconds} seconds.`);
    }
    return (
        <DashboardLayout>
            <DashboardNavbar title="Download Report" />
            <MDBox
                display="flex"
                flexDirection="column"
                justifyContent="center"
                alignItems="center"
                height="80vh"
                textAlign="center"
            >
                <h1 style={{
                    transition: 'opacity 0.5s ease-in-out',
                    opacity: 1
                }}>
                    {title}
                </h1>
                <h4 style={{
                    transition: 'opacity 0.5s ease-in-out',
                    opacity: 1
                }}>
                    {subtitle}
                </h4>
            </MDBox>
        </DashboardLayout>
    )
}

// Auxilary function that generates a part code's description
const genDescription = (partCode) => {
    // TODO
}